
import LandingLayout from "../../components/LandingLayout";
import {
    listImages
} from "../../services/images-service";

export default function Page(props) {
    return <LandingLayout
        title="Transform Your Brand with AI-Generated Logos"
        subtitle="Merging Advanced AI Technology with Your Brand Vision to Deliver Striking Logos."
        image="/new-logo.png"
        {...props}
    />;
}

export async function getServerSideProps(context) {
    const result = await listImages(20, "logo");
    return {
        props: {
            initialImages: result.slice(0, 20),
        },
    };
}
